// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"301":"f789cc0b","573":"c61a6235"}[chunkId] + ".chunk.css";
};